import React, { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import PrintableInvoice from "./PrintableInvoice";
import { SellInvoice } from "../../types/sale";
import { ReturnInvoice } from "../../types/return";
import { PurchaseInvoice } from "../../types/purchase";

interface Props {
    invoice: SellInvoice | ReturnInvoice | PurchaseInvoice;
    type: "sale" | "return" | "purchase";
    getCustomerOrSupplierName: () => string;
    getProductName: (id: string) => string;
    onAfterPrint?: () => void;
}

const InvoicePrintHandler: React.FC<Props> = ({
    invoice,
    type,
    getCustomerOrSupplierName,
    getProductName,
    onAfterPrint,
}) => {
    const printRef = useRef<HTMLDivElement>(null);
    const handlePrint = useReactToPrint({
        contentRef: printRef,
        documentTitle:
            type === "sale"
                ? "Sales Invoice"
                : type === "return"
                    ? "Return Invoice"
                    : "Purchase Invoice",
        onAfterPrint,
    });

    useEffect(() => {
        handlePrint?.();
    }, []);

    return (
        <div style={{ display: "none" }}>
            <div ref={printRef}>
                <PrintableInvoice
                    ref={null}
                    type={type}
                    invoice={invoice}
                    getCustomerOrSupplierName={getCustomerOrSupplierName}
                    getProductName={getProductName}
                />
            </div>
        </div>
    );
};

export default InvoicePrintHandler;
